<template>
  <v-container>
    <v-row>
      <v-col class="pb-0" cols="12">
        <!-- Reload button -->
        <v-btn class="primary" @click.stop="getAllBrandSheets()">
          <v-icon left>
            mdi-cached
          </v-icon> 
          Reload
        </v-btn>

        <!-- copy brand sheet link button -->
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" dense v-bind="attrs" v-on="on">
              <v-icon left>
                mdi-content-copy
              </v-icon> Copy Link
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(action, index) in menus"
              :key="index"
              @click="copyBrandSheetLink(action.value)"
            >
              <v-list-item-title>{{ action.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <input type="hidden" id="copy-brand-link" :value="brandSheetLink">
        <v-btn color="success" elevation="0" text v-if="brandLinkCopied">
          <v-icon left>
            mdi-check
          </v-icon>Copied
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="d-flex flex-row mt-3" style="justify-content:space-between;margin:0;padding:0;">
          <v-flex md6 sm6 xs12 pa-3>
            <v-card dark color="#363636" min-height="145px">
              <v-card-title class="title card-title one-line">Submissions for {{currentMonthLabel}}</v-card-title>
              <v-card-text>
                <p class="ma-0 pa-0 h3">{{totalValues.currentMonth | thousandSeprator}}</p>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md6 sm6 xs12 pa-3>
            <v-card dark color="#363636" min-height="145px">
              <v-card-title class="title card-title one-line">Total Submissions for {{currentYearLabel}}</v-card-title>
              <v-card-text>
                <p class="ma-0 pa-0 h3">{{totalValues.currentYear | thousandSeprator}}</p>
              </v-card-text>
              <v-card-actions class="pa-0">
                <v-spacer></v-spacer>
                <v-btn
                  color="secondary"
                  text
                  @click="openTotalSubmissionsModal"
                >
                  More Details
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </div>
        
        <v-card-title class="pt-0">
          <v-spacer></v-spacer>
          <v-text-field v-model="filter" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-card-title>

        <!-- BEGIN vue data table -->
        <v-data-table 
        :headers="headers" 
        :search="filter" 
        :items="items" 
        class="elevation-1">
          <template v-slot:[`item.type`]="{ item }">
            <td class="text-start">
              {{item.type === 'UGC' ? 'UGC Videos' : item.type}}
            </td>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <td class="justify-center layout px-0">
              <!-- View Button -->
              <v-btn @click="getBrandSheetDataToView(item)" color="info" class="ims-action">
                <v-icon small data-toggle="tooltip" data-placement="top" title="View Campaign">remove_red_eye</v-icon>
              </v-btn>
              <!-- View Button -->
              <v-btn @click="downloadBFS(item)" color="warning" class="ims-action">
                <v-icon color="white" small data-toggle="tooltip" data-placement="top" title="Download">download</v-icon>
              </v-btn>
            </td>
          </template>
          <template v-slot:no-data>No Data</template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- ViewBrandSheet modal -->
    <view-brand-sheet-modal v-model="viewModalDialog" :value="viewModalDialog" :brandSheetData="viewBrandSheetData" />
    
    <!-- View Total Submission Modal -->
    <total-submissions-modal 
      v-model="totalSubmissionsModalDialog"
      :value="totalSubmissionsModalDialog"
      :monthYearValues="monthYearValues"
    />
  </v-container>
</template>
<script>
import ViewBrandSheetModal from './ViewBrandSheetModal';
import campaignPDF from './campaignPDF'
import campaignConfig from './config';
import campaignAPIs from '../Campaign/campaignAPIs';
import clientAPIs from '../Client/clientAPIs'
import userAPIs from '../User/userAPIs';
import config from '@/config';
import moment from 'moment';
import utils from '../../../utils';
import TotalSubmissionsModal from './BrandFactSheet/TotalSubmissionsModal.vue';

export default {
  name: 'Brand Fact Sheet',
  components: {
    ViewBrandSheetModal,
    TotalSubmissionsModal
  },
  data() {
    return {
      viewBrandSheetData: null,
      viewModalDialog: false,
      totalSubmissionsModalDialog: false,
      allClients: [],
      allClientUsers: [],
      AM: [],
      allCampaigns: [],
      headers: [
        {
          text: 'Campaign Name',
          value: 'campaignName'
        },
        {
          text: 'Campaign Type',
          value: 'type'
        },
        {
          text: 'Client Name',
          value: 'clientName'
        },
        {
          text: 'Email',
          value: 'email'
        },
        {
          text: 'KOBE POC',
          value: 'kobePoc'
        },
        {
          text: 'Updated On',
          value: 'updatedAtDisplay'
        },
        {
          text: 'Created At',
          value: 'createdAtDisplay'
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false
        }
      ],
      items: [],
      lastUpdate: null,
      filter: '',
      campaignTypes: campaignConfig.campaignType,
      menus: [
        { title: 'UGC Form', value: 'ugcvideos' },
        { title: 'Storytell', value: 'storytell' },
        { title: 'KOBE Uncut', value: 'uncut' },
        { title: 'KOBE Lite', value: 'kobe-lite' }
      ],
      brandSheetLink: '',
      brandLinkCopied: false,
      viewID: null,
      monthYearValues: [],
      totalValues: {
        currentMonth: 0,
        currentYear: 0
      }
    }
  },
  computed: {
    currentMonthLabel() {
      return moment().format('MMM YYYY')
    },
    currentYearLabel() {
      return moment().format('YYYY')
    },
    currentUserRole: function () {
      return Number(this.$store.state.user.role)
    }
  },
  methods: {
    updateItems(response) {
      let data = response.data
      data = data.map(item => {
        let campaign = this.allCampaigns.find(c => c.id === item.campaignID)
        if (campaign) {
          item.campaignName = campaign.name
          item.clientName = this.getClientName(campaign.clientID)
          let accountManager = this.AM.find(a => campaign.assignedTo.includes(a.id))
          if (accountManager) {
            item.accountManager = `${accountManager.firstName} ${accountManager.lastName}`
          }
        } else {
          if (item.type === this.campaignTypes.STORY_TELL) {
            item.campaignName = '-'
            item.clientName = `${item.firstName} ${item.lastName}`
          } else if (item.type === this.campaignTypes.AOK) {
            item.clientName = '-'
            if (item.ugcVideo) {
              item.type = 'UGC'
            }
          }
          item.accountManager = '-'
        }
        item.updatedAtDisplay = this.formatTime(item.updatedAt)
        item.createdAtDisplay = this.formatDateTime(item.createdAt)
        item.currentMonthYearVal = moment(item.createdAt).format('YYYY-MM')
        item.currentYearVal = moment(item.createdAt).format('YYYY')
        if (item.currentMonthYearVal === moment().format('YYYY-MM')) {
          this.totalValues.currentMonth += 1
        }
        if (item.currentYearVal === moment().format('YYYY')) {
          this.totalValues.currentYear += 1
        }
        return item
      });
      this.setMonthYearValues(data)
      this.items = data
      if (this.viewID) {
        this.viewBFS()
      }
    },
    viewBFS() {
      let bfsOne = this.items.find(i => i.id === this.viewID)
      this.getBrandSheetDataToView(bfsOne)
      this.viewID = null
    },
    getAllBrandSheets() {
      this.resetValues()
      campaignAPIs
        .getAllBrandSheets()
        .then(response => {
          this.updateItems(response)
        })
        .catch(error => {
          console.log('error', error)
        });
    },
    getClientName(id) {
      let result = null;
      this.allClients.forEach(item => {
        if (item.id === id) {
          result = item.name
        }
      });
      return result;
    },
    getClientFullName(id) {
      let result = null;
      this.allClientUsers.forEach(item => {
        if (item.id === id) {
          let clientName = this.getClientName(item.clientID)
          result = `${item.firstName} ${item.lastName} (${clientName})`
        }
      });
      return result;
    },
    formatTime(value) {
      return moment(value).fromNow();
    },
    formatDateTime(value) {
      return moment(value).format('DD-MM-YYYY HH:mm:ss');
    },
    getBrandSheetDataToView(viewData) {
      this.viewBrandSheetData = viewData
      this.viewModalDialog = true;
    },
    copyBrandSheetLink(value) {
      const protocol = window.location.protocol
      const host = window.location.host
      this.brandSheetLink = `${protocol}//${host}${config.BRAND_SHEET_FORM_URL}/${value}`
      let vm = this;
      setTimeout(function() { vm.brandLinkCopied = utils.func.copyToClipboard('#copy-brand-link') }, 100)
      setTimeout(function() { vm.brandLinkCopied = false }, 1000)
    },
    async downloadBFS(item) {
      let doc = await campaignPDF.generateBFS(item)
      await campaignPDF.downloadPDF(doc, item.projectTitle || item.campaignName)
    },
    getCurrentMthYearArray() {
      const respArray = [];
      for (let i = 1; i <= 12; i++) {
        const monthStr = String(i).padStart(2, '0');
        const month = `${moment().format('YYYY')}-${monthStr}`;
        respArray.push({
          month,
          amount: ''
        });
      }
      return respArray
    },
    setMonthYearValues(data) {
      this.monthYearValues = Object.assign([], this.getCurrentMthYearArray())
      for (let mthYearObj of this.monthYearValues) {
        let totalMatches = data.filter(d => mthYearObj.month === d.currentMonthYearVal)
        mthYearObj.amount = totalMatches.length
      }
    },
    resetValues() {
      this.totalValues = {
        currentMonth: 0,
        currentYear: 0
      }
      this.monthYearValues = Object.assign([], this.getCurrentMthYearArray())
    },
    openTotalSubmissionsModal() {
      this.totalSubmissionsModalDialog = true
    }
  },
  async mounted() {
    // get Client Lists
    if (
      this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH ||
      this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW ||
      this.currentUserRole === config.userRoles.ACCOUNT_MANAGER ||
      this.currentUserRole === config.userRoles.AD_STRATEGIST
    ) {
      clientAPIs
      .getAllClients(false)
      .then(response => {
        this.allClients = response.data
      })
      .catch(error => {
        // Request failed.
        console.log('error', error)
      });

      userAPIs
        .getAllUsersByRole(config.userRoles.CLIENT)
        .then(response => {
          this.allClientUsers = response.users
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        });

      userAPIs
      .getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
      .then(response => {
        this.AM = response.users
      })
      .catch(error => {
        console.log('error', error)
      });
      this.allCampaigns = await campaignAPIs.getAllCampaignsNoStatus()
      this.getAllBrandSheets();
      if (this.$route.query.id) {
        this.viewID = this.$route.query.id
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// BrandSheetList.vue?4d11f999